<template>
  <div style="display:inline-block">
    <v-dialog v-model="showModal" persistent max-width="600">
      <template v-slot:activator="{ on }">
        <a
          href="javascript:void(0);"
          v-on="on"
          :style="{'font-size': size}"
          style="text-decoration: none;"
        >
          <i class="fas fa-question-circle"></i>
          <slot name="link"></slot>
        </a>
      </template>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="showModal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>

        <slot name="body"></slot>
        <div class="text-xs-center" style="padding: 10px 0">
          <v-btn color="grey" outline @click="showModal = false">{{$t('cancel')}}</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      default: '1.3em'
    }
  },
  data: function() {
    return {
      showModal: false
    }
  },
  mounted: function() {
    var vm = this
    document.addEventListener('keydown', e => {
      if (e.keyCode === 27) {
        vm.showModal = false
      }
    })
  },
  watch: {
    showModal: function(newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/elements/ModalHelp2.vue